import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { Router } from "@angular/router";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { CandidateService } from "../../candidate.service";
import { IFigure } from "app/auth/models/figures";
import moment from "moment";

@Component({
  selector: "app-hired-candidates-list",
  templateUrl: "./hired-candidates-list.component.html",
  styles: [""]
})
export class HiredCandidatesListComponent implements OnInit {
  public contentHeader: IContentHeader = {
    headerTitle: "MENU.HIRED_CANDIDATES",
    actionButton: false,
    breadcrumb: {
      type: "",
      links: [
        {
          name: "Home",
          isLink: true,
          link: "/"
        },
        {
          name: "MENU.RECRUITMENT",
          isLink: false
        },
        {
          name: "MENU.HIRED_CANDIDATES",
          isLink: false
        }
      ]
    }
  };
  public searchKey: string = "";
  public tableLimit: number = 10;
  public hiredCandidatesList: any = [];
  public filterList: any = [];
  public figureList: IFigure[] = [];
  public filterFigure: IFigure = { id: null, name: null, users: null };

  filterYear: number = moment().year()
  yearList =  Array.from({ length: this.filterYear - 2023 + 2 }, (v, i) => 2023 + i);

  filterFromDate: string = "";
  filterToDate: string = "";
  filterFromBargainingDate: string = "";
  filterToBargainingDate: string = "";

  filterRecruiter: { hash: string; complete_name: string } = { hash: null, complete_name: null };
  recruiterList: { hash: string; complete_name: string }[] = [];

  commercialList: { hash: string; complete_name: string }[] = [];
  filterCommercial: { hash: string; complete_name: string } = { hash: null, complete_name: null };

  constructor(
    private router: Router,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _candidateService: CandidateService,
    private _figureService: UserFigureService,
    private _userService: UserService
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_hired_candidate_list")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    await this.loadHiredCandidates();

    this.recruiterList = await this._userService.getRecruiterList();
    this.figureList = await this._figureService.getList();
    this.commercialList = await this._userService.getCommercialList();

    this._utilService.hideLoading();
  }

  async loadHiredCandidates() {
    this.hiredCandidatesList = await this._candidateService.getHiredCandidates(this.filterYear)
    await this.search();
  }

  async search() {
    const key: string = this.searchKey?.trim().toLowerCase();
    let filterList: any = this.hiredCandidatesList;

    if (key.length > 0) {
      filterList = filterList.filter((item: any) => item.complete_name?.toLowerCase().trim().includes(key) || item.working_city_name?.toLowerCase().trim().includes(key));
    }

    if (this.filterFigure && this.filterFigure.id) {
      filterList = filterList.filter((item: any) => item.figure_id === this.filterFigure.id);
    }

    if (this.filterRecruiter && this.filterRecruiter.hash) {
      filterList = filterList.filter((item: any) => item?.recruiter?.hash === this.filterRecruiter.hash);
    }

    if (this.filterFromDate && this.filterFromDate.length > 0) {
      const fromDate: moment.Moment = moment(this.filterFromDate);
      filterList = filterList.filter((item: any) => moment(item.start_date).isAfter(fromDate));
    }

    if (this.filterToDate && this.filterToDate.length > 0) {
      const toDate: moment.Moment = moment(this.filterToDate);
      filterList = filterList.filter((item: any) => moment(item.start_date).isBefore(toDate));
    }

    if(this.filterFromBargainingDate && this.filterFromBargainingDate.length > 0){
      const fromDate: moment.Moment = moment(this.filterFromBargainingDate);
      filterList = filterList.filter((item: any) => moment(item.bargaining_insert_date).isAfter(fromDate));
    }

    if(this.filterToBargainingDate && this.filterToBargainingDate.length > 0){
      const fromDate: moment.Moment = moment(this.filterToBargainingDate);
      filterList = filterList.filter((item: any) => moment(item.bargaining_insert_date).isBefore(fromDate));
    }

    if (this.filterCommercial && this.filterCommercial.hash) {
      filterList = filterList.filter((item: any) => item.commercial?.hash === this.filterCommercial.hash);
    }

    this.filterList = filterList;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async clearFilterDate(filter: string){
    this[filter] = "";
    const picker: any = document.querySelector(`#${filter} input`);
    picker.value = "";
    await this.search();
  }
}
